/** Sort key for semantic versions vX.Y */
export function versionSortKey(v: string): number {
  const match = v.match(/^v(\d+)\.(\d+)$/);
  if (!match) return -1;
  return parseInt(match[1], 10) * 1000 + parseInt(match[2], 10);
}

export function compareVersions(a: string, b: string): number {
  return versionSortKey(a) - versionSortKey(b);
}

/** Suggest the next version: v0.1→v1.0, v1.0→v1.1, v2.3→v2.4 */
export function suggestNextVersion(current: string): string {
  const match = current.match(/^v(\d+)\.(\d+)$/);
  if (!match) return current;
  const maj = parseInt(match[1], 10);
  const min = parseInt(match[2], 10);
  if (maj === 0) return "v1.0";
  return `v${maj}.${min + 1}`;
}
